const ExportModule = () => import(/* webpackChunkName: 'export' */ "./ExportModule.vue");
const SBMain = () => import(/* webpackChunkName: 'export' */ "./pages/SBMain.vue");
const Exporter = () => import(/* webpackChunkName: 'export' */ "./pages/Exporter.vue");
const Consignee = () => import(/* webpackChunkName: 'export' */ "./pages/Consignee.vue");
const InvoiceProducts = () => import(/* webpackChunkName: 'export' */ "./pages/InvoiceProducts.vue");
const AddInvoice = () => import(/* webpackChunkName: 'export' */ "./pages/AddInvoice.vue");
const FreightInsurance = () => import(/* webpackChunkName: 'export' */ "./pages/FreightInsurance.vue");
const Container = () => import(/* webpackChunkName: 'export' */ "./pages/Container.vue");
const Shipment = () => import(/* webpackChunkName: 'export' */ "./pages/Shipment.vue");
const SupportingDoc = () => import(/* webpackChunkName: 'export' */ "./pages/SupportingDoc.vue");

export const ExportRoutes = [
  {
    path: "export/:exportJobId",
    component: ExportModule,
    props: true,
    children: [
      {
        path: "/",
        name: "dashboard.export.exportee",
        redirect: { name: "dashboard.export.sbMain" }
      },
      {
        path: "sbMain",
        name: "dashboard.export.sbMain",
        component: SBMain
      },
      {
        path: "exporter",
        name: "dashboard.export.exporter",
        component: Exporter
      },
      {
        path: "consignee",
        name: "dashboard.export.consignee",
        component: Consignee
      },
      {
        path: "invoice-products",
        name: "dashboard.export.invoice-products",
        component: InvoiceProducts
      },
      {
        path: "freight-insurance",
        name: "dashboard.export.freight-insurance",
        component: FreightInsurance
      },
      {
        path: "container",
        name: "dashboard.export.container",
        component: Container
      },
      {
        path: "shipment",
        name: "dashboard.export.shipment",
        component: Shipment
      },
      {
        path: "supporting-doc",
        name: "dashboard.export.supporting-doc",
        component: SupportingDoc
      },
      {
        path: "invoice/:invoiceSrNo?",
        name: "dashboard.export.invoice-products.add-invoice",
        component: AddInvoice
      }
    ]
  }
];
